import { useMutation } from '@tanstack/react-query'

import { enableSaml } from '@src/api'
import { DefaultApiEnableSamlRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useEnableSaml = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiEnableSamlRequest) =>
      enableSaml(axiosInstance, params),
  })
}
